/* Dazzuro — les deux colonnes de la fiche produit finissent ensemble.

   La fiche est une grille de deux colonnes : a gauche la galerie, le grand
   titre et les accordeons ; a droite les infos produit, les upsells et les
   avis. Leurs hauteurs ne coincident jamais — elles dependent du nombre de
   photos, de la longueur des accordeons, du nombre d avis. La plus courte
   arrivait donc au bout bien avant l autre et laissait un grand blanc.

   Le principe : la colonne la plus COURTE est collee, la plus longue continue
   de defiler. La courte s arrete a l endroit ou elle est entierement lue, et
   attend que l autre la rattrape. Les deux se terminent au meme instant.

   Une seule formule couvre les deux cas de figure :

     top = min( sousLeHeader , hauteurFenetre - hauteurColonne )

     - colonne plus courte que la fenetre : le premier terme gagne, elle se
       cale sous le header et n en bouge plus ;
     - colonne plus haute que la fenetre : le second terme gagne et vaut un
       NOMBRE NEGATIF. Elle defile donc normalement jusqu a ce que son bas
       touche le bas de la fenetre, puis se fige la. On la lit en entier avant
       qu elle ne s immobilise.

   Le debattement disponible vient de la grille elle-meme : la rangee fait la
   hauteur de la plus grande des deux colonnes, et c est le bloc conteneur du
   position:sticky. La courte peut donc glisser exactement de l ecart entre les
   deux — ni plus, ni moins. */
(function () {
  'use strict';

  /* En dessous, la mise en page est empilee : une seule colonne, rien a
     synchroniser. Meme seuil que le passage en grille (lg:grid). */
  var LARGEUR_GRILLE = 1024;

  /* Respiration sous le header, alignee sur le padding-top de la colonne
     d infos (voir sections/main-product). */
  var RESPIRATION = 30;

  /* En dessous de cet ecart, coller une colonne se verrait plus que le blanc
     qu on cherche a supprimer. */
  var ECART_MINIMUM = 40;

  var gauche = null;
  var droite = null;
  var frame = null;

  function hauteurHeader() {
    var valeur = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--daz-header-h')
    );
    return isNaN(valeur) ? 62 : valeur;
  }

  function liberer(colonne) {
    colonne.style.position = '';
    colonne.style.top = '';
  }

  function appliquer() {
    if (!gauche || !droite) return;

    liberer(gauche);
    liberer(droite);

    if (window.innerWidth < LARGEUR_GRILLE) return;

    var hauteurGauche = gauche.offsetHeight;
    var hauteurDroite = droite.offsetHeight;
    if (Math.abs(hauteurGauche - hauteurDroite) < ECART_MINIMUM) return;

    var courte = hauteurGauche < hauteurDroite ? gauche : droite;
    var hauteurCourte = Math.min(hauteurGauche, hauteurDroite);

    /* La colonne d infos porte deja un padding-top qui la descend sous le
       header. Sans le retrancher, on ajouterait cette hauteur une seconde
       fois au moment ou elle se colle. */
    var padding = parseFloat(getComputedStyle(courte).paddingTop) || 0;

    var sousLeHeader = hauteurHeader() + RESPIRATION - padding;
    var basDeFenetre = window.innerHeight - hauteurCourte;

    courte.style.position = 'sticky';
    courte.style.top = Math.round(Math.min(sousLeHeader, basDeFenetre)) + 'px';
  }

  /* Un seul recalcul par frame : accordeons, images qui arrivent et avis
     charges en ajax declenchent souvent plusieurs mesures d affilee. */
  function programmer() {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = null;
      appliquer();
    });
  }

  function initialiser() {
    var grille = document.querySelector('.featured-product.product');
    if (!grille) return;

    gauche = grille.querySelector('.product__gallery-container');
    droite = grille.querySelector('.product__info');
    if (!gauche || !droite) return;

    appliquer();

    /* Les deux colonnes changent de hauteur en cours de route : un accordeon
       qu on ouvre, une image qui finit de charger, un bloc d avis injecte.
       L observateur ne peut pas s emballer : ce script ne touche que position
       et top, qui ne modifient pas la hauteur mesuree. */
    if (window.ResizeObserver) {
      var observateur = new ResizeObserver(programmer);
      observateur.observe(gauche);
      observateur.observe(droite);
    }

    window.addEventListener('resize', programmer);
    window.addEventListener('load', programmer);
    document.addEventListener('shopify:section:load', programmer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiser);
  } else {
    initialiser();
  }
})();
